import { Route } from '@/app/router'

const Part = () => import('./index.vue')

export default new Route('/parts/:id', Part).as('Dashboard:Part').permissions(['VIEW_PART'])
